import { MapContainer, Marker, TileLayer, Tooltip } from "react-leaflet";

import type { LatLngTuple } from "leaflet";

import type { CompanyPlace } from "components/innointel/Tools/locations";
import { mapPin } from "components/innointel/Tools/mapPins";

type MapMarker = { key: string; label: string; position: LatLngTuple };

type CompanyMapProps = { mapKey: string; places: CompanyPlace[] };

const CompanyMap = ({ mapKey, places }: CompanyMapProps) => {
  const markers = places.flatMap((place): MapMarker[] => {
    const { latitude, longitude } = place.coordinates ?? {};
    return latitude !== undefined && longitude !== undefined
      ? [
          {
            key: place.key,
            label: place.label,
            position: [latitude, longitude],
          },
        ]
      : [];
  });

  const [first] = markers;
  if (!first) {
    return null;
  }

  const mapProps =
    markers.length > 1
      ? {
          bounds: markers.map((marker) => marker.position),
          // Markers rise above their point, so the top needs room for a whole pin
          boundsOptions: {
            paddingTopLeft: [24, 48] as [number, number],
            paddingBottomRight: [24, 16] as [number, number],
          },
        }
      : { zoom: 13, center: first.position };

  return (
    <MapContainer
      key={mapKey}
      style={{ width: "100%", height: "220px", zIndex: 1, borderRadius: 8 }}
      {...mapProps}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {markers.map((marker) => (
        <Marker key={marker.key} position={marker.position} icon={mapPin()}>
          {markers.length > 1 ? <Tooltip>{marker.label}</Tooltip> : null}
        </Marker>
      ))}
    </MapContainer>
  );
};

export default CompanyMap;
